/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Delete_ButtonInputs */



/**
* | output |
* | --- |
* | "Delete Metadata" |
*
* @param {Options_Metadata_Delete_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_delete_button = /** @type {((inputs?: Options_Metadata_Delete_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Delete_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la métadonnée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удаление метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータの削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir metadados")
	return /** @type {LocalizedString} */ ("Delete Metadata")
});